import {
  I18nShape,
  useI18n,
  useStaticIntl,
} from '@tribeplatform/react-components/i18n'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Carousel } from '@tribeplatform/react-ui-kit/Carousel'

import { MemberOnboardingStep } from './Step'
import { ConfirmEmailStep, StructureStep, UploadLogoStep } from './Steps'

const placeholderStepsGenerator = (intl: I18nShape) => [
  StructureStep(intl, true, () => undefined),
  ConfirmEmailStep(intl, false, () => undefined),
  UploadLogoStep(intl, false, () => undefined),
]

export const MemberOnboardingPlaceholder = () => {
  const intl = useI18n()
  const steps = useStaticIntl(placeholderStepsGenerator)
  return (
    <Card className="overflow-hidden">
      <Card.Header
        title={intl.$t({
          defaultMessage: 'Member Onboarding',
          id: 'OnboardingPreview.Title',
        })}
        description={intl.$t({
          defaultMessage:
            'This is a preview of what actions new members are encouraged to take when they join the community.',
          id: 'OnboardingPreview.Description',
        })}
      />
      <Card.Content>
        <Carousel
          items={steps.map(step => (
            <MemberOnboardingStep step={step} key={step.title} />
          ))}
          className="px-0"
        />
      </Card.Content>
    </Card>
  )
}
